"use strict";

import angular from "angular";

import { UserDataAdapter } from "../../presentation/adpters/UserDataAdapter";

import _ from "lodash";
import { User } from "../../gateway/User/User";
import popupFeatureDialogTemplate from "../dialogs/popup-feature/popup-feature.html";

export class PopupFeatureService {
    constructor($mdDialog, DesnuDialogService) {
        this.$mdDialog = $mdDialog;
        this.DesnuDialogService = DesnuDialogService;

        this.User = new User();

        this.user = new UserDataAdapter().user();
    }

    openSteps({ flag, permission, features }, callback, callbackcancel) {
        const user = new UserDataAdapter().user();

        const hasPermission = this.User.checkPermission({
            roles: _.get(user, "roles"),
            granted: permission
        });

        const hasFlag = _.get(user, `profile.featureFlag.${flag}`);

        if (hasPermission && hasFlag !== 1) {
            this.DesnuDialogService.custom({
                controller: "PopupFeatureCtrl",
                controllerAs: "$ctrl",
                clickOutsideToClose: false,
                escapeToClose: false,
                multiple: true,
                skipHide: true,
                locals: {
                    width: "376px",
                    featureNews: true,
                    templateHtml: popupFeatureDialogTemplate,
                    title: "Novidades Nucont",
                    features
                },
                after: {
                    hide: (res) => {
                        if (callback) callback(res);
                        if (res) this.updateFlag(flag);
                    },
                    cancel: () => {
                        if (callbackcancel) callbackcancel();
                    }
                }
            });
        }
    }

    open({ flag, permission, feature }, callback, callbackcancel) {
        const user = new UserDataAdapter().user();

        const hasPermission = this.User.checkPermission({
            roles: _.get(user, "roles"),
            granted: permission
        });

        const hasFlag = _.get(user, `profile.featureFlag.${flag}`);

        if (hasPermission && hasFlag !== 1) {
            this.DesnuDialogService.custom({
                controller: "PopupFeatureCtrl",
                controllerAs: "$ctrl",
                clickOutsideToClose: false,
                escapeToClose: false,
                multiple: true,
                skipHide: true,
                locals: {
                    width: "376px",
                    featureNews: true,
                    templateHtml: popupFeatureDialogTemplate,
                    title: "Novidades Nucont",
                    feature
                },
                after: {
                    hide: (res) => {
                        if (callback) callback(res);

                        if (res) this.updateFlag(flag);
                    },
                    cancel: () => {
                        if (callbackcancel) callbackcancel();
                    }
                }
            });
        }
    }

    updateFlag(flag, accountingId) {
        const user = {
            _id: this.user._id,
            featureFlag: flag
        };
        this.User.saveMany(accountingId, [user]);
    }
}

angular
    .module("nucont.shared")
    .service("PopupFeatureService", [
        "$mdDialog",
        "DesnuDialogService",
        PopupFeatureService
    ]);
